// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q34_","content":"styles_content__2b71r","tableWrap":"styles_tableWrap__1BT2x"};